import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'endpointsFilter'
})
export class EndpointsFilterPipe implements PipeTransform {
    constructor() {}
    transform(register) {
        if(register && register.activeCalls && register.activeCalls > 0){
            return 'icon-camrecorder icons font-2xl d-block text-success m-1';
        }else {
            if(register && register.plcmH323Identity){
                if(register.plcmH323Identity.h323RegistrationState == 'ACTIVE'){
                    return 'icon-check icons font-2xl d-block text-success m-1';
                } else if(register.plcmH323Identity.h323RegistrationState == 'INACTIVE'){
                    return 'icon-arrow-down-circle icons font-2xl d-block text-danger m-1';
                } else if(register.plcmH323Identity.h323RegistrationState == 'QUARANTINED'){
                    return 'icon-ban icons font-2xl d-block text-warning m-1';
                } else {
                    return 'icon-question icons font-2xl d-block text-secondary m-1';
                }
            }else if(register && register.plcmSipIdentityV2){
                if(register.plcmSipIdentityV2.sipRegistrationState == 'ACTIVE'){
                    return 'icon-check icons font-2xl d-block text-success m-1';
                } else if(register.plcmSipIdentityV2.sipRegistrationState == 'INACTIVE'){
                    return 'icon-arrow-down-circle icons font-2xl d-block text-danger m-1';
                } else if(register.plcmSipIdentityV2.sipRegistrationState == 'QUARANTINED'){
                    return 'icon-ban icons font-2xl d-block text-warning m-1';
                } else {
                    return 'icon-question icons font-2xl d-block text-secondary m-1';
                }
            } else {
                return 'icon-question icons font-2xl d-block text-secondary m-1';
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeEndpointsFilters.ts